import { render, staticRenderFns } from "./Drukker.vue?vue&type=template&id=523e001d&scoped=true"
import script from "./Drukker.vue?vue&type=script&lang=js"
export * from "./Drukker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e001d",
  null
  
)

export default component.exports